import PropTypes from "prop-types";
import React from "react";

import { BulletList, Section } from "@swa-ui/core";
import { CheckboxFormField, useFormContext } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./MedicalEquipmentFormFields.module.scss";
import { MEDICAL_EQUIPMENT_SCHEMA_FIELD_NAMES } from "./MedicalEquipmentFormFields.schema";

const { PORTABLE_OXYGEN_CONCENTRATOR } = MEDICAL_EQUIPMENT_SCHEMA_FIELD_NAMES;

export const MedicalEquipmentFormFields = (props) => {
  const { oxygenConcentratorAssistanceFieldName = PORTABLE_OXYGEN_CONCENTRATOR } = props;
  const { watch } = useFormContext();
  const oxygenConentratorAssistanceSelected = watch(oxygenConcentratorAssistanceFieldName);

  return (
    <Section {...getSectionProps()}>
      <CheckboxFormField {...getCheckboxFormFieldProps()} />
      {renderOxygenConcentratorSubtext()}
    </Section>
  );

  function renderOxygenConcentratorSubtext() {
    return oxygenConentratorAssistanceSelected && <BulletList {...getBulletListProps()} />;
  }

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("MedicalEquipmentFormFields__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "medium",
      },
    };
  }

  function getCheckboxFormFieldProps() {
    return {
      className: styles.checkboxFormField,
      componentProps: {
        label: (
          <PlacementInfoLabel
            label="MedicalEquipmentFormFields__PORTABLE_OXYGEN_CONCENTRATOR"
            placementId="disabilityOptionOxygen"
          />
        ),
      },
      hideBottomSection: true,
      name: oxygenConcentratorAssistanceFieldName,
    };
  }
  function getBulletListProps() {
    return {
      animateInitialRender: false,
      icon: { name: "Bullet", size: "14" },
      itemClassName: styles.oxygenDevicesDisclaimer,
      items: [
        { content: i18n("MedicalEquipmentFormFields__OXYGEN_DEVICES_SUBTEXT") },
        { content: i18n("MedicalEquipmentFormFields__APPROVED_DEVICES_SUBTEXT") },
      ],
      spacing: "small",
    };
  }
};

export const medicalEquipmentFormFieldsPropTypes = {
  /** Field name for bringing own oxygen conecntrator assistance checkbox. */
  oxygenConcentratorAssistanceFieldName: PropTypes.string,
};

MedicalEquipmentFormFields.propTypes = medicalEquipmentFormFieldsPropTypes;
